<div [@routerTransition]>
    <sub-header [title]="'StockTransfers' | localize" [description]="'StockTransferHeaderInfo' | localize">
        <div role="actions">
            <div class="btn-group" dropdown placement="button right">
                <button id="dropdownButtonExcelOperations" dropdownToggle type="button"
                        class="btn btn-outline btn-outline-success btn-active-light-success dropdown-toggle me-1"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        aria-controls="dropdownMenuExcelOperations">
                    <i class="far fa-file-excel btn-md-icon"></i>
                    <span class="d-none d-md-inline-block">
                        {{ 'ExcelOperations' | localize }}
                    </span>
                </button>
                <ul id="dropdownMenuExcelOperations" class="dropdown-menu dropdown-menu-right dropdown-excel-operations"
                    role="menu" *dropdownMenu aria-labelledby="dropdownButtonExcelOperations">
                    <li role="menuitem">
                        <a class="dropdown-item text-gray-900" id="ExportAddStocksToExcelButton"
                           (click)="this.showExcelColumnSelectionModal()" href="javascript:;">
                            <i class="fa fa-download me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ExportToExcel' | localize }}
                        </a>
                    </li>

                    <!--  <li *ngIf="'Pages.AddStock.Create' | permission" role="menuitem">
                     <a href="javascript:;" class="no-padding">
                         <span class="fileinput-button">
                             <p-fileUpload mode="basic" customUpload="true" name="ExcelFileUpload" #ExcelFileUpload
                                 maxFileSize="10000000" auto="auto" accept=".csv,.xls,.xlsx"
                                 (uploadHandler)="uploadExcel($event)" (onError)="onUploadExcelError()"
                                 chooseLabel="{{ 'ImportFromExcel' | localize }}"></p-fileUpload>
                         </span>
                     </a>
                 </li> -->
                </ul>
            </div>

            <button id="btn_create_stockTransfer" *ngIf="'Pages.StockTransfer.Create' | permission"
                    (click)="createStockTransfer()" class="btn btn-primary blue">
                <i class="fa fa-plus"></i>
                {{ l('CreateNewStockTransfer') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="filterText" (ngModelChange)="getStockTransfer()"
                                               name="filterText" autoFocus type="text" class="form-control"
                                               [placeholder]="l('SearchWithThreeDot')" />
                                        <button class="btn btn-primary" type="submit" (click)="getStockTransfer()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table #dataTable (onLazyLoad)="getStockTransfer($event)"
                                 [value]="primengTableHelper.records"
                                 rows="{{ primengTableHelper.defaultRecordsCountPerPage }}" [paginator]="false"
                                 tableStyleClass="table table-bordered table-hover" [lazy]="true" [scrollable]="true"
                                 ScrollWidth="100%" [tableStyle]="{ 'min-width': '50rem' }"
                                 [resizableColumns]="primengTableHelper.resizableColumns">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%" [hidden]="
                                            !isGrantedAny('Pages.StockTransfer.Edit', 'Pages.StockTransfer.Delete')
                                        ">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="transferNo">
                                        {{ l('TransferNo') }}
                                        <p-sortIcon field="stockTransfer.transferNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="transferDate">
                                        {{ l('TransferDate') }}
                                        <p-sortIcon field="stockTransfer.stockDate"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="stockTransfer.toLocationId">
                                        {{ l('ToLocation') }}
                                        <p-sortIcon field="toLocationId"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="remarks">
                                        {{ l('Remarks') }}
                                        <p-sortIcon field="stockTransfer.remarks"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="stockQty">
                                        {{ l('Qty') }}
                                        <p-sortIcon field="stockTransfer.transferQty"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="TransferTotal">
                                        {{ l('TotalCost') }}
                                        <p-sortIcon field="stockTransfer.TransferTotal"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="TransferTotalPrice">
                                        {{ l('TotalPrice') }}
                                        <p-sortIcon field="stockTransfer.transferTotalPrice"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="status">
                                        <b>{{ l('Status') }}</b>
                                        <p-sortIcon field="stockTransfer.status"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="creationTime">
                                        {{ l('CreationTime') }}
                                        <p-sortIcon field="stockTransfer.creationTime"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td style="width: 5%" [hidden]="
                                            !isGrantedAny('Pages.StockTransfer.Edit', 'Pages.StockTransfer.Delete')
                                        ">
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.StockReceive.Create') && record.stockTransfer.status != status.Received"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                          '/app/stock/stockreceive/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.stockTransfer.id }">
                                                        {{ l('Receive/View') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.StockReceive.Create') && record.stockTransfer.status == status.Transferred"
                                                       (click)="updateStockReecive(record.stockTransfer)">
                                                        {{ l('ReceiveAll') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       (click)="print(record.stockTransfer.id)">
                                                        {{ l('Print') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('TransferNo') }}</span>
                                        {{ record.stockTransfer.transferNo }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('toLocationId') }}</span>

                                        <span *ngIf="record.stockTransfer.transferDate">
                                            {{ record.stockTransfer.transferDate | luxonFormat: "dd-LLL-yyyy" }}
                                        </span>
                                        <span *ngIf="!record.stockTransfer.transferDate">-</span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{ToLocationName}}')}}</span>
                                        {{ record.toLocationName }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Remarks') }}</span>
                                        {{ record.stockTransfer.remarks }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('StockQty') }}</span>
                                        {{ record.stockTransfer.transferQty | priceFormat }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('TotalCost') }}</span>
                                        {{ record.stockTransfer.transferTotal | priceFormat }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('TotalPrice') }}</span>
                                        {{ record.stockTransfer.transferTotalPrice | priceFormat }}
                                    </td>
                                    <td style="width: 150px" class="text-center">
                                        <span class="p-column-title">{{ l('Status') }}</span>
                                        <span class="badge" [ngClass]="utilsService.getStatusBadgeClass(record.stockTransfer.status)">
                                            <b>{{ l(status[record.stockTransfer.status]) }}</b>
                                        </span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('CreationTime') }}</span>

                                        <span *ngIf="record.stockTransfer.creationTime">
                                            {{ record.stockTransfer.creationTime | luxonFormat: "dd-LLL-yyyy HH:mm" }}
                                        </span>
                                        <span *ngIf="!record.stockTransfer.creationTime">-</span>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator [rows]="primengTableHelper.defaultRecordsCountPerPage" #paginator
                                (onPageChange)="getStockTransfer($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true" [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal></excel-column-selection-modal>
</div>
